// NEW: UI_REVAMP
import {
	Box,
	Button,
	Flex,
	Image,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Text,
	useDisclosure,
	useMediaQuery,
} from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSrvTimeApi, getSuppKeyApi, getVersionApi } from '../../api/query/authApi';
import { useBettingScreen, useGameStore } from '../../hooks/useStore';
import '../../styles/global.css';
import MenuList from './MenuList';
import './drawer.css';

dayjs.extend(utc);
dayjs.extend(timezone);

const Drawer = ({ isAgent = false, setDate, backdropFilter }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const isThirdPartyLogin = sessionStorage.getItem('isThirdPartyLogin') === 'true';
	// usemedia query
	const [isSmallerThan1024] = useMediaQuery('(max-width: 1023px)');
	// zustand
	const setSiteId = useGameStore((state) => state.setSiteId);
	const removeAll = useBettingScreen((state) => state.removeAll);
	const removeAllStl = useBettingScreen((state) => state.removeAllStl);

	// state
	const [jsParseLocal, setJsParseLocal] = useState();
	// modal
	const { isOpen, onOpen, onClose } = useDisclosure();
	//* api
	const getSrvTime = useQuery(['getSrvTimeApi'], getSrvTimeApi);
	const getVersion = useQuery(['getVersionApi'], getVersionApi);
	const getSuppKey = useQuery(['getSuppKeyApi'], getSuppKeyApi);

	// function
	const handleReload = () => {
		setTimeout(() => {
			window.location.reload();
		}, 20);
	};

	const navigateWithReset = (path) => {
		setDate(dayjs(getSrvTime.data?.currTime).utc().tz('Asia/Kuala_Lumpur').$d);
		removeAll();
		removeAllStl();
		if (path) navigate(path);
	};

	const handleBetNavigation = (siteId, path) => {
		setSiteId(siteId);

		if (location.pathname === path) {
			siteId === 1 ? removeAll() : removeAllStl();
		} else {
			navigateWithReset(path);
		}
	};

	// useEffect
	useEffect(() => {
		if (getSuppKey.isSuccess && getSuppKey.data) {
			if (localStorage.getItem(`ssupp_${getSuppKey.data?.data?.string}`)) {
				setJsParseLocal(JSON.parse(localStorage.getItem(`ssupp_${getSuppKey.data?.data?.string}`)));
			}
		}
	}, [
		getSuppKey.isSuccess,
		getSuppKey.data,
		localStorage.getItem(`ssupp_${getSuppKey.data?.data?.string}`),
	]);

	useEffect(() => {
		if (isOpen) {
			window.addEventListener('click', handleReload);
			return () => {
				window.removeEventListener('click', handleReload);
			};
		}
	}, []);

	return (
		<>
			{!isSmallerThan1024 && (
				<Box
					className='desktop-sidebar'
					width='240px'
					backdropFilter={backdropFilter}
					sx={{ WebkitBackdropFilter: backdropFilter }}
				>
					<Flex alignItems='center' mb={6} mx={4}>
						<Flex flexDirection='column'>
							<Image src='/assets/img/panalo-logo.png' width='150px' alt='panalo-logo' mb={2} />
							{getVersion.isSuccess && (
								<Text color='gray.500' fontSize='12px' width='100%' overflowX='none'>
									{getVersion.data?.version} ver.
								</Text>
							)}
						</Flex>
					</Flex>

					<Box overflowY='auto' overflowX='hidden' w='100%' flex='1' className='drawerBox'>
						<MenuList
							isAgent={isAgent}
							isThirdPartyLogin={isThirdPartyLogin}
							handleBetNavigation={handleBetNavigation}
							navigateWithReset={navigateWithReset}
							onClickLogout={() => {
								onOpen();
								if (window.smartsupp) {
									window.smartsupp(function () {
										const container = document.getElementById('smartsupp-widget-container');
										if (container && container.firstElementChild) {
											container.firstElementChild.style.zIndex = '999';
										}
										const widget = document.getElementById('widgetButtonFrame');
										if (widget && widget.firstElementChild) {
											widget.firstElementChild.style.zIndex = '999';
										}
									});
								}
							}}
						/>
					</Box>
					<Text
						display='flex'
						alignItems='center'
						justifyContent='center'
						py={4}
						color='#4F4F4F'
						fontSize='10px'
						textAlign='center'
						zIndex={1002}
					>
						© 2026 PANALO29 ALL RIGHT RESERVED.
					</Text>
				</Box>
			)}

			{isOpen && (
				<Modal isOpen={isOpen} onClose={onClose} isCentered>
					<ModalOverlay />
					<ModalContent marginX={3} zIndex={'19000001'}>
						<ModalCloseButton />
						<ModalHeader></ModalHeader>
						<ModalBody>
							<Flex>
								<Text fontSize='18px' margin='20px'>
									Sure to logout?
								</Text>
							</Flex>

							<Flex justifyContent='flex-end' width='100%' align='flex-end' marginY='20px'>
								<Button
									bgColor='blue.700'
									onClick={() => {
										onClose();
										navigate('/');
										removeAll();
										removeAllStl();
										if (window.ReactNativeWebView) {
											localStorage.clear();
										}
										sessionStorage.clear();
										if (window.smartsupp && jsParseLocal) {
											if (
												jsParseLocal.opened === 'true' ||
												jsParseLocal.message !== undefined ||
												jsParseLocal.message !== ''
											) {
												delete jsParseLocal.opened;
												delete jsParseLocal.message;
												localStorage.setItem(
													`ssupp_${getSuppKey.data?.data?.string}`,
													JSON.stringify(jsParseLocal),
												);
											}
										}
									}}
									marginRight={2}
								>
									<Text color='white'>OK</Text>
								</Button>
								<Button onClick={onClose}>
									<Text>Cancel</Text>
								</Button>
							</Flex>
						</ModalBody>
					</ModalContent>
				</Modal>
			)}
		</>
	);
};

export default Drawer;
export { DrawerButton } from './DrawerButton';

export function DrawerNavLink({ name }) {
	return (
		<Text
			ml={8}
			fontSize={['16px', '16px', '16px', '16px', '16px', '16px', '19.2px']}
			fontWeight='500'
		>
			{name}
		</Text>
	);
}
